import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const News = [
    {
      id: "1",
      category: "tax",
    },
    {
      id: "2",
      category: "labor",
    },
    {
      id: "3",
      category: "general",
    },
    {
      id: "4",
      category: "fdi",
    },
  ];

const MobileNav = ({ closeSidebar, services }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Get the current path
  const location = useLocation();

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const [isDropdownOpenService, setIsDropdownOpenService] = useState(false);

  // Get the current path
  // Toggle dropdown visibility
  const toggleDropdownSercie = () => {
    setIsDropdownOpenService(!isDropdownOpenService);
  };

  const [isDropdownOpenColumn, setIsDropdownOpenColumn] = useState(false);

  // Get the current path
  // Toggle dropdown visibility
  const toggleDropdownColumn = () => {
    setIsDropdownOpenColumn(!isDropdownOpenColumn);
  };

  return (
    <div className="w-full">
      <ul className="flex flex-col gap-5 w-full">
        <Link to="/">
          <li
            onClick={closeSidebar}
            className={`text-lg font-jost ${
              location.pathname === "/" ? "text-blue-500" : "text-white"
            }`}
          >
            Home
          </li>
        </Link>
        {/* <Link to="/gallery">
          {" "}
          <li
            onClick={closeSidebar}
            className={`text-lg font-jost ${
              location.pathname.includes("/gallery")
                ? "text-blue-500"
                : "text-white"
            }`}
          >
            gallery
          </li>
        </Link> */}
        <li
          onClick={toggleDropdown}
          className={`text-lg font-jost text-white cursor-pointer flex justify-between items-center ${
            location.pathname === "/bangladesh-subsidiary" ||
            location.pathname === "/corporate-philosophy" ||
            location.pathname === "/group-company" ||
            location.pathname === "/team"
              ? "text-blue-500"
              : "text-white"
          }`}
        >
          About Us
          <button className="flex flex-row justify-between">
            <span className="ml-2 text-2xl">
              {isDropdownOpen ? (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTIxLjgwNSAxMjEuODA0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJNNy4zMDggNjguMjExaDEwNy4xODhhNy4zMDkgNy4zMDkgMCAwIDAgNy4zMDktNy4zMSA3LjMwOCA3LjMwOCAwIDAgMC03LjMwOS03LjMwOUg3LjMwOGE3LjMxIDcuMzEgMCAwIDAgMCAxNC42MTl6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              ) : (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              )}
            </span>
          </button>
        </li>
        {isDropdownOpen && (
          <ul className=" ml-2 flex flex-col gap-3">
            <li onClick={closeSidebar}>
              <Link
                className={`text-md font-jost  ${
                  location.pathname === "/bangladesh-subsidiary"
                    ? "text-blue-500 border-b border-blue-500"
                    : "text-gray-200 border-b border-gray-600"
                }`}
                to="/bangladesh-subsidiary"
              >
                Company Profile
              </Link>
            </li>
            <li onClick={closeSidebar}>
              <Link
                className={`text-md font-jost ${
                  location.pathname === "/corporate-philosophy"
                    ? "text-blue-500 border-b border-blue-500"
                    : "text-gray-200 border-b border-gray-600"
                }`}
                to="/corporate-philosophy"
              >
                Corporate Philosophy
              </Link>
            </li>
            
            <li onClick={closeSidebar}>
              <Link
                className={`text-md font-jost ${
                  location.pathname === "/group-company"
                    ? "text-blue-500 border-b border-blue-500"
                    : "text-gray-200 border-b border-gray-600"
                }`}
                to="/group-company"
              >
                Group Company
              </Link>
            </li>
            <li onClick={closeSidebar}>
              <Link
                className={`text-md font-jost border-b ${
                  location.pathname === "/team" 
                    ? "text-blue-500 border-b border-blue-500"
                    : "text-gray-200 border-b border-gray-600"
                }`}
                to="/team"
              >
                Team
              </Link>
            </li>
          </ul>
        )}
        <li
          onClick={toggleDropdownSercie}
          className={`text-lg font-jost flex flex-row justify-between items-center ${
            location.pathname.includes("/service")
              ? "text-blue-500"
              : "text-white"
          }`}
        >
          Service
          <button className="flex flex-row justify-between">
            <span className="ml-2 text-2xl">
              {isDropdownOpenService ? (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTIxLjgwNSAxMjEuODA0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJNNy4zMDggNjguMjExaDEwNy4xODhhNy4zMDkgNy4zMDkgMCAwIDAgNy4zMDktNy4zMSA3LjMwOCA3LjMwOCAwIDAgMC03LjMwOS03LjMwOUg3LjMwOGE3LjMxIDcuMzEgMCAwIDAgMCAxNC42MTl6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              ) : (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              )}
            </span>
          </button>
        </li>
        {isDropdownOpenService && (
          <div>
            {services.map((service, index) => (
              <ul key={service._id} className="ml-2 flex flex-col">
                <li
                  className={`text-md font-jost mt-6 ${
                    location.pathname === `/service/${service._id}`
                      ? "text-blue-500 border-b border-blue-500"
                      : "text-gray-200 border-b border-gray-600"
                  }`}
                >
                  <Link to={`/service/${service._id}`}>
                    {index + 1} {service.service.charAt(0).toUpperCase() + service.service.slice(1)}
                  </Link>
                </li>
              </ul>
            ))}
          </div>
        )}
        <li
          onClick={toggleDropdownColumn}
          className={`text-lg font-jost flex flex-row justify-between items-center ${
            location.pathname.includes("/career-category/") 
              ? "text-blue-500"
              : "text-white"
          }`}
        >
          Column
          <button className="flex flex-row justify-between">
            <span className="ml-2 text-2xl">
              {isDropdownOpenColumn ? (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTIxLjgwNSAxMjEuODA0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJNNy4zMDggNjguMjExaDEwNy4xODhhNy4zMDkgNy4zMDkgMCAwIDAgNy4zMDktNy4zMSA3LjMwOCA3LjMwOCAwIDAgMC03LjMwOS03LjMwOUg3LjMwOGE3LjMxIDcuMzEgMCAwIDAgMCAxNC42MTl6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              ) : (
                <img
                  className="w-4 h-4"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                />
              )}
            </span>
          </button>
        </li>
        {isDropdownOpenColumn && (
          <div>
            {News.map((news, index) => (
              <ul key={news._id} className=" ml-2 flex flex-col">
                <li
                  className={`text-md font-jost mt-5 ${
                    location.pathname === `/career-category/${news.category}` 
                      ? "text-blue-500 border-b border-blue-500"
                      : "text-gray-200 border-b border-gray-600"
                  }`}
                >
                  <Link to={`/career-category/${news.category}`}>
                    {index + 1} {news.category.charAt(0).toUpperCase() + news.category.slice(1)}
                  </Link>
                </li>
              </ul>
            ))}
          </div>
        )}
           
          <Link to="/gallery">
          <li
          onClick={closeSidebar}
           className={`text-lg font-jost ${
            location.pathname === "/gallery" ||
            location.pathname.includes("/gallery-details/") ? "text-blue-500" : "text-white"
          }`}
          
          >
            News
          </li> 
        </Link>
        <Link to="/career">
          <li
             onClick={closeSidebar}
              className={`text-lg font-jost ${
                location.pathname === "/career" ? "text-blue-500" : "text-white"
              }`}
          >
            Career
          </li>
        </Link>
        <Link to="/consultation">
          <li
          onClick={closeSidebar}
           
              className={`text-lg font-jost ${
                location.pathname === "/consultation" ? "text-blue-500" : "text-white"
              }`}
          >
            Get free consultation
          </li>
        </Link>
      </ul>
    </div>
  );
};

export default MobileNav;
